import difference from 'lodash/difference';
import validUrl from 'valid-url';

export interface AlternateURL {
  href: string;
  hrefLang: string;
}

export interface Location {
  hostname: string;
  path: string;
  query: string;
}

export interface CountryCode {
  id: string;
  isoCode: string;
}

const regexp = new RegExp('^/.*?(/|$)');

const englishHrefLang = (countryISO: string): string => {
  return `en-${countryISO}`;
};

const buildURL = (hostname: string, countryISO: string, noCountryPath: string): string => {
  const filtered = [hostname, countryISO, noCountryPath].filter(el => el.length !== 0);
  return `https://${filtered.join('/')}`;
};

const generateAlternateURLs = (
  countries: CountryCode[],
  location: Location,
  exclusions: string[],
  countryCode: string,
): AlternateURL[] => {
  let exclusionsCleaned = exclusions;
  if (!exclusionsCleaned) {
    exclusionsCleaned = [];
  }

  const { hostname, path } = location;
  const noCountryPath = path.replace(regexp, '');

  let finalCountries = difference(
    countries.map(el => el.isoCode.toLowerCase()),
    exclusionsCleaned.map(el => el.toLowerCase()),
  );

  finalCountries = finalCountries.filter(el => el !== countryCode);

  return finalCountries
    .map(countryISO => {
      const href = buildURL(hostname, countryISO, noCountryPath);
      const hrefLang = englishHrefLang(countryISO);
      if (!validUrl.isUri(href)) {
        return null;
      }
      return { href, hrefLang };
    })
    .filter(el => el);
};

export { generateAlternateURLs };
